var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCashSearch = function SvgCashSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8915 11.5931C8.1079 11.8777 8.38981 12.1059 8.71329 12.2583C9.03677 12.4106 9.39224 12.4826 9.7495 12.4681C10.8885 12.4681 11.8125 11.7751 11.8125 10.9211C11.8125 10.0671 10.8885 9.37411 9.7495 9.37411C8.6105 9.37411 7.6875 8.68111 7.6875 7.82611C7.6875 6.97111 8.6105 6.27911 9.7495 6.27911C10.1067 6.26488 10.4621 6.33698 10.7855 6.4893C11.109 6.64161 11.3909 6.86966 11.6075 7.15411",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.4688V13.4998",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 5.25V6.28",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.812C0.75 12.2154 1.70474 14.5203 3.4042 16.2198C5.10365 17.9193 7.40861 18.874 9.812 18.874C12.2154 18.874 14.5203 17.9193 16.2198 16.2198C17.9193 14.5203 18.874 12.2154 18.874 9.812C18.874 7.40861 17.9193 5.10365 16.2198 3.4042C14.5203 1.70474 12.2154 0.75 9.812 0.75C7.40861 0.75 5.10365 1.70474 3.4042 3.4042C1.70474 5.10365 0.75 7.40861 0.75 9.812V9.812Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2207 16.2188L23.2497 23.2488",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCashSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cash_search.88c55d5ce33a78e14eb0f0014d03553c.svg";